import { FC, useRef, useMemo } from 'react';
import dynamic from 'next/dynamic';
import styled from 'styled-components';
import { useOnScreen } from '../../../hooks/useOnScreen';
import { Color } from '../../Theme';
import { FakeGraph } from '../FakeGraph';
import type { LineGraphProps } from './LineGraphContent';

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 280px;

  > div {
    padding-top: 169.88%;
  }

  > svg,
  > img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: visible;

    .tick,
    .domain {
      color: ${Color.background};
    }

    text {
      color: ${Color.black};
    }
  }

  > img {
    transform: translate(60, 10);
    opacity: 0.05;
  }
`;

export const LineGraph: FC<LineGraphProps> = ({ data, scale }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const isVisible = useOnScreen(containerRef, { onlyOnce: true });

  // Import graph only if required
  const LineGraphContent = useMemo(
    () =>
      isVisible
        ? dynamic(() => import('./LineGraphContent').then(({ LineGraphContent }) => LineGraphContent), { loading: () => <FakeGraph /> })
        : FakeGraph,
    [isVisible]
  );

  return (
    <Container ref={containerRef}>
      <LineGraphContent data={data} scale={scale} />
    </Container>
  );
};
